import { StepProgress, type Step } from '@/shared/ui/primitives';

import type { LabOrderWizardStepId } from '../model/types.js';

const EXISTING_TEST_STEPS: Array<Step<LabOrderWizardStepId>> = [
  { id: 'select-test', label: 'Lab Test' },
  { id: 'disease-codes', label: 'Details' },
  { id: 'review', label: 'Review' },
];

const CUSTOM_TEST_STEPS: Array<Step<LabOrderWizardStepId>> = [
  { id: 'select-test', label: 'Lab Test' },
  { id: 'custom-test', label: 'Build' },
  { id: 'disease-codes', label: 'Details' },
  { id: 'review', label: 'Review' },
];

function getVisibleSteps(
  mode: 'existing_test' | 'custom_test' | null
): Array<Step<LabOrderWizardStepId>> {
  if (mode === 'custom_test') return CUSTOM_TEST_STEPS;
  return EXISTING_TEST_STEPS;
}

export interface LabOrderWizardProgressProps {
  stepId: LabOrderWizardStepId;
  mode: 'existing_test' | 'custom_test' | null;
}

export function LabOrderWizardProgress({ stepId, mode }: LabOrderWizardProgressProps) {
  const visibleSteps = getVisibleSteps(mode);
  const activeId = stepId === 'confirmation' ? 'review' : stepId;

  return (
    <StepProgress
      steps={visibleSteps}
      currentStepId={activeId}
      showLabels={false}
      easing="easeOutQuad"
    />
  );
}
